import styled from 'styled-components';
import { Button as AntButton, Typography, Tag as AntTag } from 'antd';
import { Link } from 'react-router-dom';

const { Title: AntTitle, Text: AntText } = Typography;

export const UtxoDetailsContainer = styled.div`
  background-color: #ffffff;
  min-height: 100vh;
`;

// Main Content
export const MainContent = styled.div`
  padding: 40px 0px;
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const PageTitle = styled(AntTitle)`
  font-family: 'Poppins', sans-serif !important;
  font-weight: 600 !important;
  font-size: 24px !important;
  color: #141413 !important;
  margin: 0 !important;
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const UtxoTreeBtn = styled(AntButton)`
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 0 16px !important;
  height: 40px !important;
  background-color: #f5f5f5 !important;
  border: none !important;
  border-radius: 25px !important;
  color: #141413 !important;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;
`;

export const FreezeBtn = styled(AntButton)`
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 0 16px !important;
  height: 40px !important;
  background-color: rgba(248, 152, 61, 0.12) !important;
  border: none !important;
  border-radius: 25px !important;
  color: #f8983d !important;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;
`;

// UTXO ID Section
export const UtxoIdSection = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 14px 20px;
  background-color: rgba(243, 245, 242, 0.5);
  border-radius: 10px;
  margin-bottom: 20px;
`;

export const UtxoIdText = styled(AntText)`
  font-family: 'Poppins', sans-serif !important;
  font-size: 16px !important;
  color: #141413 !important;
  flex: 1;
`;

export const CopyBtn = styled(AntButton)`
  border: none !important;
  padding: 0 !important;
  width: 14px !important;
  height: 14px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  opacity: 0.6;
`;

export const CopyBtnSmall = styled(AntButton)`
  border: none !important;
  padding: 0 !important;
  width: 16px !important;
  height: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  opacity: 0.6;
`;

// Overview Section
export const OverviewSection = styled.div`
  margin-bottom: 40px;
`;

export const SectionTitle = styled(AntTitle)`
  font-family: 'Poppins', sans-serif !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  color: #141413 !important;
  margin-bottom: 20px !important;
`;

export const InfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(16, 41, 0, 0.1);
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  min-height: 56px;
`;

export const InfoLabel = styled.span`
  width: 180px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #141413;
  opacity: 0.6;
  padding: 10px 24px 10px 0;
`;

export const InfoValue = styled.div`
  flex: 1;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #141413;
  padding: 10px 32px;
`;

export const RecipientValue = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const RecipientAddress = styled(AntText)`
  max-width: 800px !important;
  font-size: 16px !important;
`;

// Status Tags
export const StatusTag = styled(AntTag)<{ $status: 'active' | 'spent' | 'freeze' }>`
  border: none !important;
  padding: 4px 6px !important;
  border-radius: 4px !important;
  font-family: 'Poppins', sans-serif !important;
  font-size: 16px !important;
  font-weight: 400 !important;

  ${(props) => {
    switch (props.$status) {
      case 'active':
        return `
          background-color: rgba(166, 235, 122, 0.2) !important;
          color: #388506 !important;
        `;
      case 'spent':
        return `
          background-color: #f5f5f5 !important;
          color: #141413 !important;
        `;
      case 'freeze':
        return `
          background-color: rgba(248, 152, 61, 0.12) !important;
          color: #f8983d !important;
        `;
      default:
        return '';
    }
  }}
`;

// Tabs Section
export const TabsSection = styled.div`
  margin-top: 40px;
`;

export const TabButtons = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
`;

export const TabBtn = styled(AntButton)<{ $active?: boolean }>`
  padding: 8px 12px !important;
  border: none !important;
  border-radius: 6px !important;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  background-color: ${(props) => (props.$active ? '#141413' : '#f5f5f5')} !important;
  color: ${(props) => (props.$active ? '#ffffff' : '#141413')} !important;
`;

// Transaction Hash Content
export const TxHashContent = styled.div`
  margin-top: 20px;
`;

export const TxHashGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 40px;
`;

export const TxHashSection = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  .copy-btn {
    opacity: 0;
    pointer-events: none;
    transition: all ease 0.2s;
  }
  &:hover {
    .copy-btn {
      opacity: 1;
      pointer-events: inherit;
    }
  }
`;

export const TxHashHeader = styled.div`
  background-color: #ffffff;
  border-bottom: 1px solid rgba(16, 41, 0, 0.1);
  padding: 10px 24px 10px 0;
`;

export const TxHashLabel = styled.span`
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #141413;
`;

export const TxHashValue = styled(Link)`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px 10px 0;
  background-color: #ffffff;
  flex: 1;
  cursor: pointer;
`;

export const HashText = styled(AntText)`
  font-family: 'Poppins', sans-serif !important;
  font-size: 16px !important;
  color: #388506 !important;
  opacity: 0.9;
  // max-width: 601px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  word-break: break-all;
  line-height: 1.4;
`;

// Family Tables
export const FamilyTables = styled.div`
  display: flex;
  margin-top: 40px;
`;

export const FamilyTableSection = styled.div`
  width: 100%;
`;

export const OperateButtons = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const OperateBtn = styled(AntButton)`
  width: 36px !important;
  height: 36px !important;
  border: none !important;
  background-color: #f5f5f5 !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  .anticon {
    color: #141413 !important;
    font-size: 20px !important;
  }
`;

// UTXO Tree Content
export const UtxoTreeContent = styled.div`
  padding: 40px 0;
  text-align: center;
  color: #141413;
  opacity: 0.6;
`;

// Global Table Styles
export const StyledTable = styled.div`
  .ant-table-thead > tr > th {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    color: #141413 !important;
    background-color: #ffffff !important;
    border-bottom: 1px solid rgba(16, 41, 0, 0.1) !important;
  }

  .ant-table-tbody > tr > td {
    font-family: 'Poppins', sans-serif !important;
    font-size: 16px !important;
    color: #141413 !important;
    opacity: 0.9;
    border-bottom: 1px solid rgba(16, 41, 0, 0.1) !important;
  }

  @media (max-width: 768px) {
    .ant-table-thead {
      display: none;
    }

    .ant-table-tbody > tr {
      display: block;
      border: 1px solid rgba(16, 41, 0, 0.1);
      border-radius: 8px;
      margin-bottom: 16px;
      padding: 16px;
      background: #ffffff;
    }

    .ant-table-tbody > tr > td {
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      border-bottom: none !important;
      padding: 8px 0 !important;
      gap: 8px;

      &:before {
        content: attr(data-label);
        font-weight: 600;
        color: rgba(20, 20, 0, 0.6);
        font-size: 14px;
        display: block;
      }

      &:last-child {
        border-bottom: none !important;
      }
    }
  }
`;

// Responsive styles
export const ResponsiveWrapper = styled.div`
  padding-bottom: 100px;
  max-width: var(--pc-max-width);
  padding: 0 40px;
  margin: 0 auto;
  @media (max-width: 1200px) {
    ${MainContent} {
      padding: 40px;
    }

    ${TxHashGrid} {
      grid-template-columns: 1fr;
    }

    ${FamilyTables} {
      grid-template-columns: 1fr;
    }

    ${FamilyTableSection} {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    padding: 0 16px;
    padding-bottom: 60px;

    ${MainContent} {
      padding: 20px 0;
    }

    ${HeaderSection} {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }

    ${PageTitle} {
      font-size: 24px !important;
    }

    ${UtxoIdSection} {
      padding: 12px 16px;
      margin-bottom: 16px;
    }

    ${UtxoIdText} {
      font-size: 14px !important;
      word-break: break-all;
    }

    ${OverviewSection} {
      margin-bottom: 32px;
    }

    ${SectionTitle} {
      font-size: 18px !important;
      margin-bottom: 16px !important;
    }

    ${InfoRow} {
      flex-direction: column;
      align-items: flex-start;
      min-height: auto;
      padding: 16px 0;
      gap: 12px;
    }

    ${InfoLabel} {
      width: 100%;
      margin-bottom: 0;
      padding-right: 0;
    }

    ${InfoValue} {
      padding: 0;
      width: 100%;
    }

    ${TabsSection} {
      margin-top: 32px;
    }

    ${TabButtons} {
      margin-bottom: 16px;
    }

    ${TabBtn} {
      font-size: 14px !important;
      padding: 6px 10px !important;
    }

    ${TxHashGrid} {
      grid-template-columns: 1fr;
      gap: 16px;
      margin-bottom: 32px;
    }

    ${TxHashSection} {
      .copy-btn {
        opacity: 1;
        pointer-events: inherit;
      }
    }

    ${TxHashHeader} {
      padding: 8px 0;
    }

    ${TxHashValue} {
      padding: 8px 0;
    }

    ${HashText} {
      font-size: 14px !important;
      word-break: break-all;
      white-space: normal !important;
      line-height: 1.4 !important;
    }

    ${FamilyTables} {
      margin-top: 32px;
    }

    ${OperateBtn} {
      width: 32px !important;
      height: 32px !important;

      .anticon {
        font-size: 16px !important;
      }
    }
  }
`;
